"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var deserializerMiddleware_1 = require("./deserializerMiddleware");

var serializerMiddleware_1 = require("./serializerMiddleware");

exports.deserializerMiddlewareOption = {
  name: "deserializerMiddleware",
  step: "deserialize",
  tags: ["DESERIALIZER"]
};
exports.serializerMiddlewareOption = {
  name: "serializerMiddleware",
  step: "serialize",
  tags: ["SERIALIZER"]
};

function getSerdePlugin(config, serializer, deserializer) {
  return {
    applyToStack: function applyToStack(commandStack) {
      commandStack.add(deserializerMiddleware_1.deserializerMiddleware(config, deserializer), exports.deserializerMiddlewareOption);
      commandStack.add(serializerMiddleware_1.serializerMiddleware(config, serializer), exports.serializerMiddlewareOption);
    }
  };
}

exports.getSerdePlugin = getSerdePlugin;